import { render, staticRenderFns } from "./voec-details.vue?vue&type=template&id=62c20f4a&lang=pug"
import script from "./voec-details.vue?vue&type=script&lang=ts"
export * from "./voec-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports